/**
 * AWS Cognito configuration for development (web.wisk.dev, feature*.wisk.dev)
 * passwordPolicy must match your Cognito User Pool's password policy
 */
export default {
  useCognitoAuth: true,
  userPoolId: 'us-east-1_q8VYDbRnw',
  clientId: '27fthj7h4ne86dmov0fg8s4jj4',
  region: 'us-east-1',
  passwordPolicy: {
    minLength: 8,
    requireUppercase: true,
    requireLowercase: true,
    requireNumbers: true,
    requireSymbolsOrSpace: true,
    noLeadingTrailingSpace: true
  }
}
